<template>
  <section class="edit-text-box animated fadeInUp">
    <div class="edit-text-inner">
      <div class="audio-inner" @click="handleToggle">
        <i v-if="!audioFlag" class="iconfont glin-yuyin"></i>
        <i v-else class="iconfont glin-jianpanTalk-keyboard"></i>
      </div>
      <div class="input-inner">
        <input
          v-if="!audioFlag"
          type="text"
          v-model="sendControl.content"
          placeholder="点击提问问题"
          @input="handleInput"
          @blur="handleBlur"
          @keyup.enter="handleSubmit"
        />
        <audio-input v-else @error="onAudioError" />
      </div>
      <div class="photo-inner" @click="$refs.file.click()">
        <i class="iconfont glin-tupian1"></i>
      </div>
      <div class="face-inner" @click="faceVisible = !faceVisible">
        <i
          class="iconfont glin-emoji_icon"
          :class="{ active: faceVisible }"
        ></i>
      </div>
      <!-- <div
        class="btn-inner"
        :class="{ active: sendControl.content }"
        @click="handleSubmit"
      ></div> -->
    </div>
    <input
      type="file"
      ref="file"
      accept="image/jpeg, image/jpg, image/png"
      v-show="false"
      @change="onUploadChange($event)"
    />
    <face-select :visible.sync="faceVisible" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import faceSelect from './faceSelect'
import audioInput from './audioInput'
import { getSystem } from '@/assets/script/utils'

export default {
  data() {
    return {
      audioFlag: false,
      enterFlag: true,
      faceVisible: false
    }
  },
  computed: {
    ...mapState(['chatControl', 'sendControl', 'relevantControl'])
  },
  methods: {
    handleToggle() {
      if (getSystem.isIOS) {
        this.$createDialog({
          type: 'alert',
          content: '【提示】iOS系统中微信内置程序暂不支持语音功能，敬请理解！',
          icon: 'cubeic-alert'
        }).show()
        return
      }
      this.audioFlag = !this.audioFlag
    },

    handleInput() {
      if (this.chatControl.connected) {
        const { content } = this.sendControl
        if (this.enterFlag && content.length > 0) {
          this.sendControl.entering('focus')
          this.enterFlag = false
        }

        if (content.length <= 0) {
          this.handleBlur()
        }
      } else {
        this.relevantControl.addList(this.sendControl.content)
      }
    },

    handleBlur() {
      this.enterFlag = true
      this.sendControl.entering('blur')
    },

    handleSubmit() {
      const { content } = this.sendControl
      if (!content) return

      if (this.chatControl.connected) {
        this.handleBlur()
      }
      this.chatControl.addInfoBySend(content)
      this.sendControl.clear()
      this.relevantControl.clear()
    },

    onUploadChange(e) {
      const file = e.target.files[0]
      this.sendControl.addImage(file)
    },

    onAudioError(err) {
      this.audioFlag = false
      this.$createToast({
        txt: '当前平台暂不支持语音功能',
        type: 'warn'
      }).show()
      console.error(err)
    }
  },
  components: {
    faceSelect,
    audioInput
  }
}
</script>

<style lang="stylus">
.edit-text-box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 99;

  .edit-text-inner {
    display: flex;
    padding: 5px 10px;

    .audio-inner, .face-inner, .photo-inner {
      // flex: 0 0 37px;
      width: 37px;
      flex: none;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .iconfont {
        font-size: 1.65rem;
        color: #999;

        &.active {
          color: #193a79;
        }
      }
    }

    .input-inner {
      flex: 1;
      height: 40px;

      input {
        width: 100%;
        height: 40px;

        &:focus {
          outline: none;
        }
      }
    }

    .btn-inner {
      position: relative;
      flex: 0 0 40px;
      height: 40px;
      margin-left: 15px;
      background: url('~@/assets/image/send@3x.png');
      background-repeat: no-repeat;
      background-position: center right;
      background-size: auto 70%;

      &.active {
        animation: btnRotate 0.2s;
        transform: rotate(-45deg);
        background: url('~@/assets/image/send-hover@3x.png');
        background-repeat: no-repeat;
        background-position: center right;
        background-size: auto 70%;
      }

      @keyframes btnRotate {
        0% {
          transform: rotate(0);
        }

        100% {
          transform: rotate(-45deg);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/sendBox.vue